import { DadosClienteProps } from "../../types/DadosClienteProps";
import InputMask from 'react-input-mask'

export function DadosPrincipais({ register, cliente, inputDisabled, errors } : DadosClienteProps){
  return(
    <>
      <div className="flex flex-row flex-wrap justify-between">
        <div>
          <label className="font-[500]" htmlFor="Nome">Nome do Cliente <span className="text-red-500">*</span></label>
          <input 
            type="text"
            required
            {...register("Nome", {required: !cliente?.Nome && true})}
            defaultValue={cliente?.Nome}
            disabled={inputDisabled}
            name="Nome"
            className={`input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3] ${(!cliente?.Nome && errors?.Nome) && 'focus:outline-none focus:ring-2 focus:ring-error'}`}
            />
        </div>
        <div>
          <label className="font-[500]" htmlFor="Website">Web Site</label>
          <input 
            type="text"
            {...register("Website")}
            defaultValue={cliente?.Website}
            disabled={inputDisabled}
            name="Website"
            maxLength={50}
            className="input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
          />
        </div>
        <div>
          <label className="font-[500]" htmlFor="TelefoneComercial">Telefone Comercial</label>
          {
            inputDisabled ?

            <input
            type="text"
            {...register("TelefoneComercial")}
            defaultValue={cliente?.TelefoneComercial}
            disabled={inputDisabled}
            name="TelefoneComercial"
            className="input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
            /> :
            <InputMask
            type="text"
            mask={'(99) 9999-9999'}
            {...register("TelefoneComercial")}
            defaultValue={cliente?.TelefoneComercial}
            disabled={inputDisabled}
            name="TelefoneComercial"
            className="input-login-style w-[25rem] mb-5"
            />
          }
        </div>
        <div>
          <label className="font-[500]" htmlFor="TelefoneCelularTelefone Celular">Telefone Celular</label>
          { inputDisabled ?
            <input
            type="text"
            {...register("TelefoneCelular")}
            defaultValue={cliente?.TelefoneCelular}
            disabled={inputDisabled}
            name="TelefoneCelular"
            className="input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
            /> :
          <InputMask
            type="text"
            mask={'(99) 99999-9999'}
            {...register("TelefoneCelular")}
            defaultValue={cliente?.TelefoneCelular}
            disabled={inputDisabled}
            name="TelefoneCelular"
            className="input-login-style w-[25rem] mb-5"
            />
          }
        </div>
        <div>
          <label className="font-[500]" htmlFor="TelefoneFax">Telefone Fax</label>
          {
            inputDisabled ?
            <input
            type="text"
            {...register("TelefoneFax")}
            defaultValue={cliente?.TelefoneFax}
            disabled={inputDisabled}
            name="TelefoneFax"
            className="input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
            /> :
            <InputMask
            type="text"
            mask={'(99) 9999-9999'}
            {...register("TelefoneFax")}
            defaultValue={cliente?.TelefoneFax}
            disabled={inputDisabled}
            name="TelefoneFax"
            className="input-login-style w-[25rem] mb-5"
            />
          }
        </div>
        <div>
          <label className="font-[500]" htmlFor="EmailPrincipal">
            E-mail
          </label>
          <input 
            type="text"
            {...register("EmailPrincipal")}
            defaultValue={cliente?.EmailPrincipal}
            disabled={inputDisabled}
            name="EmailPrincipal"
            maxLength={50}
            className="input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
          />
        </div>
      </div>
      <div className="w-full">
        <label className="font-[500]" htmlFor="Observacoes">Observações</label>
        <textarea 
          className="input-login-style w-full mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
          {...register("Observacoes")}
          defaultValue={cliente?.Observacoes}
          disabled={inputDisabled}
          name="Observacoes"
          maxLength={300}
          ></textarea> 
      </div>
      <div>
        <span className="text-red-500">Os campos com * são obrigatórios.</span>
      </div>
    </>
  );
}
